import { MapContainer, TileLayer } from "react-leaflet";
import { useState, useEffect } from "react";
import "leaflet/dist/leaflet.css";
import MarkerLayer from "./markerLayer";
import data from "./innov_data_july.json";

const Map2D = () => {
  const [mapZoom, setMapZoom] = useState(3);

  useEffect(() => {
    const handleResize = () => {
      const scrWidth = window.innerWidth;
      if (scrWidth >= 2000) {
        setMapZoom(5);
      } else {
        setMapZoom(3);
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <MapContainer
      center={[40, -100]}
      key={mapZoom}
      zoom={mapZoom}
      minZoom={mapZoom}
      maxZoom={18}
      scrollWheelZoom={true}
      worldCopyJump={false}
      style={{
        width: "100%",
        height: "100%",
      }}
      maxBoundsViscosity={1.0}
      maxBounds={[
        [-90, -179.999],
        [90, 179.999],
      ]}
    >
      <TileLayer
        noWrap={true}
        attribution='<a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
      />
      <MarkerLayer data={data} />
    </MapContainer>
  );
};

export default Map2D;

